import { atom, useAtom } from 'jotai';

// holds Millada object with all append msg / export / show graph funtions
export const favouriteQuestions = atom([]);

export function useFavouriteQuestionsAtom() {
  return useAtom(favouriteQuestions);
}
